import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { TextField, withStyles } from 'vopay';
import { Button, MaterialSymbol } from 'UI';
import styles from './SearchBar.module.scss';

const cn = withStyles(styles);

type SearchBarProps = {
  name: string;
  value: string;
  onChange: (value: string) => void;
  /**
   * Fired by the Search button and the Enter key. Omit it for a search-as-you-type field: the
   * button is dropped and the caller filters straight off `value` (e.g. the Integrations catalogue).
   */
  onSearch?: () => void;
  placeholder?: string;
  className?: string;
  /** Rendered inside the input wrapper, e.g. an autocomplete dropdown positioned under the field */
  children?: ReactNode;
};

// Same field + button pairing as the other keyword search forms (e.g. BankSearchForm)
export default function SearchBar({
  name,
  value,
  onChange,
  onSearch,
  placeholder,
  className,
  children,
}: SearchBarProps) {
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });

  return (
    <div className={cn('searchBar', className)}>
      <div className={cn('inputWrapper')}>
        <TextField
          name={name}
          value={value}
          placeholder={placeholder}
          variant="outlineShadow"
          elementLeft={<MaterialSymbol icon="search" size="20px" className={cn('searchIcon')} />}
          onChange={(event) => onChange(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter') onSearch?.();
          }}
        />

        {children}
      </div>

      {onSearch && (
        <Button colorScheme="primary" size="small" onClick={onSearch}>
          {tGlobal('Buttons.search')}
        </Button>
      )}
    </div>
  );
}
